export const GET_PRE_DN_OFFLINE_REQUEST = 'GET_PRE_DN_OFFLINE_REQUEST';
export const GET_PRE_DN_OFFLINE_SUCCESS = 'GET_PRE_DN_OFFLINE_SUCCESS';
export const GET_PRE_DN_OFFLINE_ERROR = 'GET_PRE_DN_OFFLINE_ERROR';

export const DELETE_PRE_DN_OFFLINE_REQUEST = 'DELETE_PRE_DN_OFFLINE_REQUEST';
export const DELETE_PRE_DN_OFFLINE_SUCCESS = 'DELETE_PRE_DN_OFFLINE_SUCCESS';
export const DELETE_PRE_DN_OFFLINE_ERROR = 'DELETE_PRE_DN_OFFLINE_ERROR';
